export default __webpack_public_path__ + "static/media/icon-step-two1.6a1827c4.png";